import { Api } from '../services/api.ts';
import type { AtlasBibliografia } from '../types/index.ts';

let biblioCache: AtlasBibliografia[] = [];

export function initTeoria() {
  const tableBody = document.querySelector('#table-cites tbody') as HTMLTableSectionElement | null;
  const formAdd = document.getElementById('form-add-cite') as HTMLFormElement | null;

  async function loadData() {
    try {
      biblioCache = await Api.getBibliografia();
      render();
    } catch (err) {
      console.error('Error al cargar bibliografía:', err);
    }
  }

  function render() {
    if (!tableBody) return;
    tableBody.innerHTML = '';

    biblioCache.forEach((b) => {
      const tr = document.createElement('tr');
      const badgeOe = b.vinculo_oe === 'oe1' ? 'badge-active' : (b.vinculo_oe === 'oe2' ? 'badge-pending' : (b.vinculo_oe === 'oe3' ? 'badge-done' : ''));

      tr.innerHTML = `
        <td style="max-width:260px;">
          <strong>${escapeHtml(b.autor)}</strong> (${escapeHtml(b.anio)})<br>
          <span style="font-size:0.75rem; color:var(--text-muted);">${escapeHtml(b.name)}</span>
          <div style="margin-top:4px; display:flex; gap:4px; flex-wrap:wrap;">
            <button type="button" class="btn-copy-cite" data-copy="${escapeHtml(b.referencia_apa || '')}" title="Copiar referencia APA 7">
              Copiar APA 7
            </button>
            <span class="badge" style="font-size:0.68rem; background:#f1f5f9; color:#475569;">${b.tipo_fuente.toUpperCase()}</span>
          </div>
        </td>
        <td>
          <span style="font-size:0.75rem; color:var(--primary); font-weight:600;">${escapeHtml(b.eje_teorico || b.eje || '-')}</span><br>
          <small style="color:var(--text-muted); font-size:0.72rem;">${escapeHtml(b.fuente_editorial || '')}</small>
        </td>
        <td style="font-size:0.8rem; line-height:1.4;">
          <blockquote style="margin:0; padding-left:8px; border-left:2px solid var(--border-dark); font-style:italic;">
            "${escapeHtml(b.cita_clave || b.texto || '')}"
          </blockquote>
          <div style="margin-top:4px; font-family:var(--font-mono); font-size:0.72rem; color:#475569;">
            Parentética: <b>${escapeHtml(b.cita_parentetica || `(${b.autor}, ${b.anio})`)}</b> | 
            Narrativa: <b>${escapeHtml(b.cita_narrativa || `${b.autor} (${b.anio})`)}</b>
          </div>
        </td>
        <td><span style="font-family:var(--font-mono); font-size:0.75rem;">${escapeHtml(b.paginas || '-')}</span></td>
        <td><span class="badge ${badgeOe}" style="font-size:0.72rem;">${(b.vinculo_oe || b.oe || 'transversal').toUpperCase()}</span></td>
        <td style="text-align:center;">
          <button data-del-id="${b.id}" class="btn-del" title="Eliminar referencia de SQLite">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
          </button>
        </td>
      `;
      tableBody.appendChild(tr);
    });

    // Botones de copiar cita
    tableBody.querySelectorAll('.btn-copy-cite').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const text = (e.currentTarget as HTMLElement).getAttribute('data-copy');
        if (text) {
          navigator.clipboard.writeText(text);
          const original = btn.textContent;
          btn.textContent = '¡Copiado!';
          setTimeout(() => { btn.textContent = original; }, 1500);
        }
      });
    });

    // Eliminar cita
    tableBody.querySelectorAll('button[data-del-id]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.getAttribute('data-del-id');
        if (!id) return;
        if (confirm('¿Eliminar esta referencia bibliográfica de SQLite?')) {
          try {
            await Api.deleteBibliografia(id);
            biblioCache = biblioCache.filter(c => c.id !== parseInt(id));
            render();
          } catch (err) {
            alert('Error al eliminar cita de SQLite');
          }
        }
      });
    });
  }

  formAdd?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const authorInput = document.getElementById('cite-author') as HTMLInputElement | null;
    const yearInput = document.getElementById('cite-year') as HTMLInputElement | null;
    const titleInput = document.getElementById('cite-title') as HTMLInputElement | null;
    const typeInput = document.getElementById('cite-type') as HTMLSelectElement | null;
    const editorialInput = document.getElementById('cite-editorial') as HTMLInputElement | null;
    const axisInput = document.getElementById('cite-axis') as HTMLSelectElement | null;
    const textInput = document.getElementById('cite-text') as HTMLTextAreaElement | null;
    const pagesInput = document.getElementById('cite-pages') as HTMLInputElement | null;
    const oeInput = document.getElementById('cite-oe') as HTMLSelectElement | null;
    const doiInput = document.getElementById('cite-doi') as HTMLInputElement | null;

    if (!authorInput?.value.trim()) return;

    const autor = authorInput.value.trim();
    const anio = yearInput?.value.trim() || '2026';
    const titulo = titleInput?.value.trim() || `Publicación de ${autor}`;
    const tipo = (typeInput?.value || 'libro') as any;
    const editorial = editorialInput?.value.trim() || '';
    const eje = axisInput?.value || 'Genealogía del Glitch';
    const texto = textInput?.value.trim() || '';
    const paginas = pagesInput?.value.trim() || '';
    const oe = (oeInput?.value || 'transversal') as any;
    const doi = doiInput?.value.trim() || '';

    // Auto-generación de formato APA 7
    const primerApellido = autor.split(',')[0].trim();
    const apaString = `${autor} (${anio}). ${titulo}. ${editorial}${doi ? ` ${doi}` : ''}.`;
    const parentetica = `(${primerApellido}, ${anio})`;
    const narrativa = `${primerApellido} (${anio})`;

    try {
      const res = await Api.addBibliografia({
        name: titulo,
        tipo_fuente: tipo,
        autor,
        anio,
        fuente_editorial: editorial,
        eje_teorico: eje,
        cita_clave: texto,
        paginas,
        vinculo_oe: oe,
        url_doi: doi,
        referencia_apa: apaString,
        cita_parentetica: parentetica,
        cita_narrativa: narrativa
      });

      if (res.ok) {
        formAdd.reset();
        await loadData();
      }
    } catch (err) {
      alert('Error al guardar referencia APA en SQLite');
    }
  });

  loadData();
}

function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.innerText = str || '';
  return div.innerHTML;
}
